
<template>
   <svg xmlns="http://www.w3.org/2000/svg" width="60px" height="70px" viewBox="0 0 50 80" xml:space="preserve">
    <polyline style="fill:none;stroke:#313131;stroke-width:5" stroke-linejoin="round" points="30.5,60.8 0.375,38.087 30.5,15.375" fill="none"/>
     <line x1="2" y1="38" x2="60" y2="38" stroke-width="5" stroke="#313131" fill="none" />
  </svg> 
</template>

<script>
    export default {

    }
</script>
